import { bool, number, string, object, func, node, oneOf, oneOfType } from "prop-types";
import {
  Dialog as MuiDialog,
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { isMobile } from "react-device-detect";
import useStyle from "./Dialog.style";
import classnames from "classnames";
import { isArray } from "lodash";
import { useMemo } from "react";

export const Dialog = ({
  id,
  open=false,
  children,
  actions,
  titleActions,
  title,
  onClose,
  useCloseButton=true,
  useBackdropClick=true,
  actionsAlignment="end",
  forceCloseButton,
  width,
  minWidth,
  height,
  className,
  containerClass,
  titleContainerClass,
  actionsClass,
  titleClass,
  rootClass,
  containerId,
  style,
  variant,
  fullActionPaddings,
  animateWidthChange,
  ...rest
}) => {
  const classes = useStyle();
  
  const parsedChildren = useMemo(() => {
    if(isArray(children)) {
      const filtered = children.filter(child => child);
      return filtered?.length ? filtered : undefined;
    }
    return children;
  }, [children]);
  
  return (
    <MuiDialog
      {...rest}
      open={open}
      onClose={useBackdropClick ? onClose : null}
      className={rootClass}
      PaperProps={{
        id,
        className: classnames(
          classes.root,
          animateWidthChange && classes.animateWidth,
          variant && classes[`variant-${variant}`],
          className
        ),
        style: width
          ? {
              width,
              minWidth,
              maxWidth: "90vw",
              ...(height ? { height } : {}),
              ...(style || {}),
            }
          : style,
      }}
    >
      {
        (title || forceCloseButton) &&
        <DialogTitle
          disableTypography
          className={classnames(
            isMobile && classes.mobileTitleContent,
            variant && classes[`variant-${variant}`],
            titleContainerClass,
          )}
        >
          {typeof title === "string" ? (
            <h2 className={titleClass}>{title}</h2>
          ) : (
            title
          )}
          { titleActions }
          {
            useCloseButton && onClose &&
            <IconButton
              color="primary"
              aria-label="close modal"
              onClick={onClose}
            >
              <Close />
            </IconButton>
          }
        </DialogTitle>
      }
      {Boolean(parsedChildren) && (
        <DialogContent
          className={classnames(
            isMobile && classes.mobileContent,
            !actions && "border-none",
            containerClass
          )}
          id={containerId}
        >
          {parsedChildren}
        </DialogContent>
      )}
      {Boolean(actions) && (
        <DialogActions
          className={classnames(
            fullActionPaddings
              ? "p-6"
              : classes.actions,
            classes[actionsAlignment + "Alignment"],
            isMobile && classes.mobileActionsContent,
            actionsClass
          )}
        >
          {actions}
        </DialogActions>
      )}
    </MuiDialog>
  );
};

Dialog.propTypes = {
  id: string,
  open: bool,
  onClose: func,
  title: oneOfType([string, node]),
  children: node,
  actions: node,
  titleActions: node,
  className: string,
  style: object,
  containerId: string,
  rootClass: string,
  containerClass: string,
  titleContainerClass: string,
  actionsClass: string,
  titleClass: string,
  width: number,
  minWidth: number,
  height: number,
  useCloseButton: bool,
  forceCloseButton: bool,
  fullActionPaddings: bool,
  useBackdropClick: bool,
  animateWidthChange: bool,
  actionsAlignment: oneOf(["start", "end", "spaceBetween"]),
  variant: oneOf(["info", "warning", "danger"]),
};